import React from "react";
import { Card, Grid } from "semantic-ui-react";
import { i18next } from "@translations/invenio_app_rdm/i18next";

const DepositStatusBoxes = ({ children }) => {
  return (
    <div>
      <Card>{children}</Card>
      <Card>
        <Card.Content>
          <Grid relaxed>
            <Grid.Column width={16} className="pt-14 pb-14">
              <a
                id="completion-guide-btn"
                href="/upload-completion-guide"
                target="_blank"
                class="ui medium fluid icon left labeled button"
              >
                <i class="question icon"></i>
                {i18next.t("Completion guide")}
              </a>
            </Grid.Column>
          </Grid>
        </Card.Content>
      </Card>
    </div>
  );
};

export default DepositStatusBoxes;
